import { PriceControlItemDTO } from '../dto';
import { dateFromString } from '@retail/utils';
import { DiscountGroup, PriceSuggestionType, ProductGroupBase } from '@retail/products/types';
import { PriceControlPrices } from './PriceControlPrices';
export type PriceControlChangeType =
  | 'AGREEMENT_PRICE'
  | 'PRICE_SUGGESTION'
  | 'AGREEMENT_PRICE_AND_PRICE_SUGGESTION';

export type PriceControlAction =
  | 'KEEP_OLD_COVERAGE'
  | 'SPLIT_DIFFERENCE'
  | 'KEEP_OLD_PRICE'
  | 'FREEZE_OLD_PRICE'
  | 'FREEZE_CUSTOM_PRICE'
  | 'CUSTOM_MARKUP'
  | 'CUSTOM_COVERAGE_DEGREE'
  | 'DO_NOTHING';

export class PriceControlItem {
  memberEventId: number;
  mgItemNumber: number;
  finfoNumber: number;
  nobbNumber: number;
  primaryText: string;
  secondaryText: string;
  primaryUnit: string;
  discountGroup?: DiscountGroup;
  productGroup: ProductGroupBase;
  changeDate: Date;
  eventType: PriceControlChangeType;
  pricesExVat?: PriceControlPrices;
  pricesIncVat?: PriceControlPrices;
  purchasePriceDiffPercentage: number;
  salesPriceDiffPercentage: number;
  salesFactorBefore: number;
  salesFactorAfter: number;
  salesFactorDiffPercentage: number;
  coverageDegreeBefore: number;
  coverageDegreeAfter: number;
  isHandled: boolean;
  priceSourceBefore: PriceSuggestionType;
  handledAction?: PriceControlAction;
  handledAtDate?: Date;
  validActions: PriceControlAction[];

  constructor({
    memberEventId,
    mgItemNumber,
    finfoNumber,
    nobbNumber,
    primaryText,
    secondaryText,
    primaryUnit,
    discountGroup,
    productGroup,
    changeDate,
    eventType,
    pricesExVat,
    pricesIncVat,
    purchasePriceDiffPercentage,
    salesPriceDiffPercentage,
    salesFactorBefore,
    salesFactorAfter,
    salesFactorDiffPercentage,
    coverageDegreeBefore,
    coverageDegreeAfter,
    isHandled,
    priceSourceBefore,
    handledAction,
    handledAtDate,
    validActions,
  }: PriceControlItem) {
    this.memberEventId = memberEventId;
    this.mgItemNumber = mgItemNumber;
    this.finfoNumber = finfoNumber;
    this.nobbNumber = nobbNumber;
    this.primaryText = primaryText;
    this.secondaryText = secondaryText;
    this.discountGroup = discountGroup;
    this.productGroup = productGroup;
    this.primaryUnit = primaryUnit;
    this.changeDate = changeDate;
    this.eventType = eventType;
    this.pricesExVat = pricesExVat;
    this.pricesIncVat = pricesIncVat;
    this.purchasePriceDiffPercentage = purchasePriceDiffPercentage;
    this.salesPriceDiffPercentage = salesPriceDiffPercentage;
    this.salesFactorBefore = salesFactorBefore;
    this.salesFactorAfter = salesFactorAfter;
    this.salesFactorDiffPercentage = salesFactorDiffPercentage;
    this.coverageDegreeBefore = coverageDegreeBefore;
    this.coverageDegreeAfter = coverageDegreeAfter;
    this.isHandled = isHandled;
    this.priceSourceBefore = priceSourceBefore;
    this.handledAction = handledAction;
    this.handledAtDate = handledAtDate;
    this.validActions = validActions;
  }

  static fromDto = (dto: PriceControlItemDTO): PriceControlItem =>
    new PriceControlItem({
      memberEventId: dto.memberEventId,
      mgItemNumber: dto.mgItemNumber,
      finfoNumber: dto.finfoNumber,
      nobbNumber: dto.nobbNumber,
      primaryText: dto.primaryText,
      secondaryText: dto.secondaryText,
      discountGroup: dto.discountGroup ? DiscountGroup.fromDto(dto.discountGroup) : undefined,
      productGroup: dto.productGroup,
      primaryUnit: dto.primaryUnit,
      changeDate: dateFromString(dto.changeDate)!,
      eventType: dto.eventType,
      pricesExVat: dto.pricesExVat ? PriceControlPrices.fromDto(dto.pricesExVat) : undefined,
      pricesIncVat: dto.pricesIncVat ? PriceControlPrices.fromDto(dto.pricesIncVat) : undefined,
      purchasePriceDiffPercentage: dto.purchasePriceDiffPercentage,
      salesPriceDiffPercentage: dto.salesPriceDiffPercentage,
      salesFactorBefore: dto.salesFactorBefore,
      salesFactorAfter: dto.salesFactorAfter,
      salesFactorDiffPercentage: dto.salesFactorDiffPercentage,
      coverageDegreeBefore: dto.coverageDegreeBefore,
      coverageDegreeAfter: dto.coverageDegreeAfter,
      isHandled: dto.isHandled,
      priceSourceBefore: dto.priceSourceBefore,
      handledAction: dto.handledAction,
      handledAtDate: dateFromString(dto.handledAtDate),
      validActions: dto.validActions,
    });
}
